import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


//************* POSGRADO  ***************************/
import { Interceptor } from '../../token/interceptor';
import { ViewUiteyTituloPosgradoService } from '../viewUiteyTituloPosgrado/viewUiteyTituloPosgrado.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedPosgradoModule {
  static forRoot(): ModuleWithProviders<SharedPosgradoModule> {
    return {
      ngModule: SharedPosgradoModule,
      providers: [
        ViewUiteyTituloPosgradoService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
